// icons
import { MdDashboard } from "react-icons/md";

const administradorCircuito = {
    id: 'administrador-circuito-group',
    type: 'group',
    roles: [1,100,200],
    breadcrumbs: false,
    children: [
      {
        id: 'administrador-circuito',
        title: "Administrador de Circuito",
        type: 'item',
        breadcrumbs: false,
        icon: MdDashboard,
        url: '/circuito/administrador-circuito',
        roles: [1,100,200],
      },
    ]
};

export default administradorCircuito;